<div class="grid-layout carousel is-set static-carousel">
  @for (item of categories; track item) {
    <div class="item">
      <div>
        <div class="item-contents">
          <a (click)="navigate('/category/' + item.slug)">
            <div class="image">
              <img
                src="{{ item.imageUrl }}"
                loading="lazy"
                alt="{{ item.title }}"
                />
            </div>
          </a>
        </div>
      </div>
    </div>
  }
</div>